module.exports = {"511403115":"武阳镇","511403116":"江口镇","511403117":"凤鸣镇","511403118":"公义镇","511403119":"牧马镇","511403120":"谢家镇","511403121":"黄丰镇","511403122":"观音镇","511403123":"彭溪镇","511403124":"青龙镇","511403214":"保胜乡","511403215":"义和乡","511403216":"锦江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511403.json
// module id = 2167
// module chunks = 0